import dragdrop from './dragdrop';
import explorerSidebar from './explorerSidebar';
import settingsModal from './settingsModal';
import notepad from './notepad';
import sessionStorage from './sessionStorage';
import pdfViewer from './pdfViewer';
import magicClipboard from './magicClipboard';

const viewsModule = {
  namespaced: true,
  modules: {
    dragdrop,
    explorerSidebar,
    settingsModal,
    notepad,
    sessionStorage,
    pdfViewer,
    magicClipboard
  },
  state: () => ({}),
  getters: {},
  mutations: {},
  actions: {}
};

export default viewsModule;
